import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CountriesService } from '@core/services/countries.service';

export const countryResolver: ResolveFn<void> = () => {
  return inject(CountriesService).setCountriesWithRegions();
};
